module.exports = "{{{contacticon this class=\"profileiconbig\" gravatarclass=\"gravatariconbig\"}}}"